










import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Popup extends Vue {
  @Prop({ type: Boolean, default: false })
  visible!: boolean

  compVisible = false
  delayVisble = false
  timer: any

  @Watch('visible', { immediate: true })
  watchVisible(newval: boolean) {
    if (newval) {
      document.body.style.overflow = 'hidden'
      this.compVisible = true
      this.timer = setTimeout(() => {
        this.delayVisble = true
        clearTimeout(this.timer)
      }, 20)
    } else {
      document.body.style.overflow = 'auto'
      this.delayVisble = false
      this.timer = setTimeout(() => {
        this.compVisible = false
        clearTimeout(this.timer)
      }, 300)
    }
  }

  beforeDestroy() {
    document.body.style.overflow = 'auto'
  }
}
